import nanostyled from 'nanostyled';

export const Container = nanostyled('div', {
  base: 'w-full',
  margin: 'mx-auto',
});
